import { useQuery } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { Question, DealQuestionAnswer } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useDealQuestionsQuery() {
	const api = useApi();

	return useQuery(QueryKeys.Questions.LoanApp, () => {
		return AxiosUtils.getResponseData<Question[]>(api.get(CerebroApiEndpoints.Questions.LoanApp));
	});
}
